<template>
  <div class="collection-title-wrapper">
    <div>
      <div class="author">
        <marquee :animate="showCollection">
          {{ collectionInfo?.name }}
        </marquee>
        <span
          class="focus"
          @click="followCollection"
        >关注</span>
      </div>
      <div class="play-num">
        {{ playNum }}次播放
      </div>
    </div>
    <div class="feed-number">
      <div>视频数</div>
      <div>{{ feedNumDesc }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store/index';
import { addNumUint } from '@/utils/number';
import Marquee from '@/components/common/marquee.vue';

const emits = defineEmits(['on-follow-collection']);

const { state } = useStore();
const showCollection = computed(() => state.showCollection);
const collectionInfo = computed(() => state.collectionInfo);
const activeIndex = computed(() => state.activeIndex);
const feedNumDesc = computed(() => (`${activeIndex.value + 1} / ${collectionInfo.value?.feedNum || 12}`)); // 10/12
const playNum = computed(() => addNumUint(collectionInfo.value?.playNum || 0, 'cn'));

const followCollection = () => {
  emits('on-follow-collection');
};
</script>

<style lang="scss" scoped>
@import '@/styles/transform.scss';
.collection-title-wrapper {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  @include responsiveStyleSingle(padding-left, 2.6667,'vw');
  @include responsiveStyleSingle(padding-right, 2.6667,'vw');
  top: 0;
  left: 0;
  right: 0;
  background: #000;
  z-index: 15;
  & > div:first-child {
    @include responsiveStyleSingle(width, 72.5333, 'vw');
  }
  .author {
    display: flex;
    align-items: center;
    @include responsiveStyleSingle(margin-top, 2.6667, 'vw');
    font-weight: bold;
    @include responsiveStyleSingle(font-size, 4.8, 'vw');
    @include responsiveStyleSingle(line-height, 8, 'vw');
    color: #fff;
    overflow: hidden;
    .focus {
      @include responsiveStyleSingle(margin-left, 1.0667, 'vw');
      flex-grow: 0;
      flex-shrink: 0;
      @include responsiveStyleSingle(flex-basis, 10.1333, 'vw');
      @include responsiveStyleSingle(margin-left, 1.0667, 'vw');
      @include responsiveStyleSingle(height, 5.8667, 'vw');
      @include responsiveStyleSingle(line-height, 5.8667, 'vw');
      @include responsiveStyleSingle(font-size, 3.2, 'vw');
      font-weight: bold;
      text-align: center;
      background: #7a46ff;
      @include responsiveStyleSingle(border-radius, 2.9333, 'vw');
    }
  }
  .play-num {
    color: rgba(255, 255, 255, 0.7);
    @include responsiveStyleSingle(font-size, 3.2, 'vw');
    @include responsiveStyleSingle(line-height, 4.2667, 'vw');
  }
  .feed-number {
    box-sizing: border-box;
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
    div {
      @include responsiveStyleSingle(line-height, 4.4, 'vw');
      &:first-child {
        @include responsiveStyleSingle(margin-bottom, 0.9333, 'vw');
      }
    }
  }
}
</style>
